import { cx } from '@twind/core';
import { HTMLAttributes, PropsWithChildren } from 'react';

interface MessageBubbleProps extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
  isAuthor?: boolean;
}

const MessageBubble = ({ children, isAuthor = false, className, ...rest }: MessageBubbleProps) => {
  return (
    <div
      style={{ wordBreak: 'break-word' }}
      className={cx(
        '~(rounded-2xl grow font-normal text-sm whitespace-pre-line [&_a]:(underline underline-offset-2) [&_p]:(mb-2 empty:pb-[1em] last-of-type:mb-0))',
        isAuthor ? '~(bg-brand-primary px-5 py-3)' : '',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default MessageBubble;
